import { render, staticRenderFns } from "./UserRegistrationComplete.vue?vue&type=template&id=9174ae70"
import script from "./UserRegistrationComplete.vue?vue&type=script&lang=js"
export * from "./UserRegistrationComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports